import { Controller } from 'stimulus';

export default class extends Controller {
  close() {
    if (window.opener) {
      const win = window.open("","_self"); /* url = "" or "about:blank"; target="_self" */
      win.close();
    } else {
      window.history.back();
    }
  }

  back() {
    window.history.back();
  }

  redirectToEdcast() {
    if(window.location.href.includes('https://iob.ie/'))
      window.location.href = 'https://lms.iob.ie/my/'
    else
      window.location.href = 'https://ioblearn-uat.iob.ie/'
  }
}
